__turbopack_context__.v({
  "modal": "BACLya_modal",
  "modal__actions": "BACLya_modal__actions",
  "modal__description": "BACLya_modal__description",
  "modal__title": "BACLya_modal__title",
  "shimmer": "BACLya_shimmer",
  "text-bar-sweep": "BACLya_text-bar-sweep",
});
